import { AnchorHTMLAttributes, FC } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { cn } from '@/lib/utils';

type LinkProps = Omit<RouterLinkProps, 'to'> & {
  to: RouterLinkProps['to'];
  className?: string;
  /** Ignored — kept so unmigrated call sites that still pass MUI `sx` don't crash. */
  sx?: unknown;
};

const isExternalHref = (to: RouterLinkProps['to']): to is string =>
  typeof to === 'string' && /^(https?:|mailto:|tel:)/i.test(to);

/**
 * App link: React Router for internal routes, plain <a> for external/mailto.
 */
const Link: FC<LinkProps> = ({ to, className, sx: _sx, children, ...props }) => {
  const classes = cn(
    'text-primary underline-offset-4 transition-colors hover:underline',
    className
  );

  if (isExternalHref(to)) {
    const anchorProps = props as AnchorHTMLAttributes<HTMLAnchorElement>;
    return (
      <a href={to} className={classes} {...anchorProps}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={to} className={classes} {...props}>
      {children}
    </RouterLink>
  );
};

export default Link;
